import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_dw_button = _resolveComponent("dw-button")!
  const _component_dw_popup = _resolveComponent("dw-popup")!

  return (_openBlock(), _createBlock(_component_dw_popup, {
    title: "Добавление в лист ожидания",
    onClose: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "dw-popup__form",
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
      }, [
        _createVNode(_component_the_select, {
          value: _ctx.state.statusCode,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.statusCode) = $event)),
          placeholder: "Выберите статус",
          options: _ctx.statuses_state.list,
          loading: _ctx.statuses_state.is_loading,
          failed: _ctx.statuses_state.is_failed,
          "error-text": "При получении списка статусов произошла ошибка",
          "search-without-refresh": "",
          "select-by": "code",
          disabled: _ctx.state.is_loading,
          "is-invalid": _ctx.validation$.statusCode.$error,
          "validation-errors": _ctx.validation$.statusCode.$errors,
          onRefresh: _ctx.loadWaitListStatuses,
          onChange: _ctx.onStatusChange
        }, null, 8, ["value", "options", "loading", "failed", "disabled", "is-invalid", "validation-errors", "onRefresh", "onChange"]),
        (_ctx.isDate)
          ? (_openBlock(), _createBlock(_component_the_input, {
              key: 0,
              value: _ctx.state.newDate,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.newDate) = $event)),
              placeholder: "Выберите новую дату",
              type: "date",
              "is-invalid": _ctx.validation$.newDate.$error,
              "validation-errors": _ctx.validation$.newDate.$errors,
              disabled: _ctx.state.is_loading
            }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]))
          : _createCommentVNode("", true),
        _createVNode(_component_the_select, {
          value: _ctx.state.comment,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.comment) = $event)),
          placeholder: "Комментарий",
          options: _ctx.comments_state.list,
          loading: _ctx.comments_state.is_loading,
          failed: _ctx.comments_state.is_failed,
          "error-text": "При получении списка произошла ошибка",
          "search-without-refresh": "",
          "select-by": "text",
          label: "text",
          disabled: _ctx.state.is_loading,
          onRefresh: _ctx.loadWaitListComments,
          onChange: _ctx.onCommentChange
        }, null, 8, ["value", "options", "loading", "failed", "disabled", "onRefresh", "onChange"]),
        (_ctx.state.is_other)
          ? (_openBlock(), _createBlock(_component_the_input, {
              key: 1,
              value: _ctx.state.comment_other,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.comment_other) = $event)),
              placeholder: "Напишите комментарий",
              disabled: _ctx.state.is_loading
            }, null, 8, ["value", "disabled"]))
          : _createCommentVNode("", true),
        _createVNode(_component_dw_button, {
          type: "submit",
          loading: _ctx.state.is_loading
        }, {
          default: _withCtx(() => [
            _createTextVNode("Добавить в лист ожидания")
          ]),
          _: 1
        }, 8, ["loading"])
      ], 32)
    ]),
    _: 1
  }, 8, ["onClose"]))
}